import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import { useSelector } from "react-redux"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/users/user-1.jpg"
import axios from "axios"
import config from "config/config"
import SnackbarComponent from "components/SnackBar"
import MFAInput from "components/Common/MFAInput"

const UserActionDropDown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const userData = useSelector(state => state.Login.userData)
  const [mfaModalOpen, setMfaModalOpen] = useState(false)
  const [mfaError, setMfaError] = useState("")
  const [loading, setLoading] = useState(false)
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const deleteUser = async id => {
    try {
      const response = await axios.put(
        `${config.backendUrl}/user/disableUser?userId=${id}`,
        { organizationId: activeOrganization.id }, // put request body (empty in this case)
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      props.fetchUsers()
      props.setSuccess("User disabled successfully.")
    } catch (err) {
      console.log(err)
      props.setErr("Error occured while disabling user.")
    }
  }
  const enableUser = async id => {
    try {
      const response = await axios.put(
        `${config.backendUrl}/user/enableUser?userId=${id}`,
        { organizationId: activeOrganization.id }, // put request body (empty in this case)
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      props.fetchUsers()
      props.setSuccess("User enabled successfully.")
    } catch (err) {
      console.log(err)
      props.setErr("Error occured while enabling user.")
    }
  }

  const handleMfaSubmit = async code => {
    setMfaError("")
    setLoading(true)
    try {
      // Call 2FA verification API using fetch
      const response = await fetch(
        `${process.env.REACT_APP_API_URL || config.backendUrl}/auth/2fa/verify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData?.token}`,
          },
          body: JSON.stringify({ code, email: userData?.email }),
        },
      )
      const result = await response.json()
      if (response.status === 200 && result.userInfo) {
        // Proceed to save profile changes
        if (props.isActive) {
          deleteUser(props.id)
        } else {
          enableUser(props.id)
        }
        setMfaModalOpen(false)
        setLoading(false)
      } else {
        setMfaError(result.message || "Invalid MFA code.")
        setLoading(false)
      }
    } catch (err) {
      setMfaError("Error verifying 2FA code.")
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <MFAInput
        isOpen={mfaModalOpen}
        toggle={() => {
          setMfaModalOpen(false)
          // setPendingProfileData(null)
          setMfaError("")
        }}
        onSubmit={handleMfaSubmit}
        error={mfaError}
      />
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn"
          id="page-header-user-dropdown"
          tag="button"
        >
          <i className="mdi mdi-dots-vertical" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end" positionFixed>
          <DropdownItem tag="a" href={`/user/update/${props.id}`}>
            {" "}
            <i className="mdi mdi-update font-size-17 text-muted align-middle me-1" />
            {props.t("Update")}{" "}
          </DropdownItem>
          {props.isActive ? (
            <DropdownItem
              tag="a"
              onClick={() => {
                setMfaModalOpen(true)
              }}
            >
              {" "}
              <i className="mdi mdi-update font-size-17 text-muted align-middle me-1" />
              {props.t("Disable")}{" "}
            </DropdownItem>
          ) : (
            <DropdownItem
              tag="a"
              onClick={() => {
                setMfaModalOpen(true)
              }}
            >
              {" "}
              <i className="mdi mdi-update font-size-17 text-muted align-middle me-1" />
              {props.t("Enable")}{" "}
            </DropdownItem>
          )}

          {/* <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="mdi mdi mdi-account-group font-size-17 text-muted align-middle me-1" />
            <span>{props.t("Users")}</span>
          </Link> */}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

UserActionDropDown.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(UserActionDropDown)),
)
